import { ComponentType } from "@/queries/models/types";
import { observer } from "mobx-react-lite";
import { InputParameterBuilder } from "../InputParameterBuilder";
import { SliderParameterBuilder } from "../SliderParameterBuilder";
import { DropdownParameterBuilder } from "../DropdownBuilder";
import { GroupParameterBuilder } from ".";
import { BuilderProps } from "../types";

export const ParameterEditor = observer(
  ({ parameter, isViewing, isNested }: BuilderProps) => {
    const parameterType = parameter.componentType;

    switch (parameterType) {
      case ComponentType.INPUT:
        return (
          <InputParameterBuilder parameter={parameter} isViewing={isViewing} />
        );
      case ComponentType.DROPDOWN:
        return (
          <DropdownParameterBuilder
            parameter={parameter}
            isViewing={isViewing}
          />
        );
      case ComponentType.SLIDER:
        return (
          <SliderParameterBuilder parameter={parameter} isViewing={isViewing} />
        );
      case ComponentType.GROUP:
        return (
          <GroupParameterBuilder
            isNested={isNested}
            parameter={parameter}
            isViewing={isViewing}
          />
        );
      default:
        return null;
    }
  },
);
